<div class="container-fluid mat-elevation-z8">
  <div class="loading-shade" *ngIf="isLoading || hasError">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <div class="has-error" *ngIf="hasError">
      There was an error loading the message flags.
    </div>
  </div>

  <div class="w-100 p-3">
    <h2 class="page-title">Message Flags</h2>
    <p class="page-hint">
      Senders whose chat messages tripped a spam/scam rule — pushes to Telegram or WhatsApp,
      investment and crypto pitches, money requests, and identical messages mass-sent to many
      matches. Use the flag button to see every flagged message and what triggered it.
    </p>
  </div>

  <div class="w-100 px-3">
    <mat-form-field class="w-100">
      <mat-label>Search Query</mat-label>
      <input matInput placeholder="User ID, email or name" (change)="queryChanged($event)">
    </mat-form-field>
  </div>

  <div class="w-100 px-3">
    <sa-timezone-toggle></sa-timezone-toggle>
  </div>

  <section class="w-100 p-3 d-flex flex-wrap align-items-center">
    <mat-form-field class="reason-filter me-3">
      <mat-label>Reason</mat-label>
      <mat-select [value]="reason | async" (selectionChange)="reasonChanged($event.value)">
        <mat-option value="">All reasons</mat-option>
        <mat-option *ngFor="let item of reasons" [value]="item.code">{{ item.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [checked]="reportedOnly | async" (change)="reportedOnlyChanged($event.checked)">
      Only users who were also reported or blocked
    </mat-checkbox>
  </section>

  <!-- The same table component /users renders, so the photo strip and the full
       action set are identical here by construction rather than by copy. -->
  <div class="w-100">
    <sa-users-table
      [displayedColumns]="displayedColumns"
      [data]="data"
      [initialSort]="initialSort"
      (userClicked)="userClicked($event)"
      (userBanClicked)="userBanClicked($event)"
      (userUnBanClicked)="userUnBanClicked($event)"
      (userPutUnderReviewClicked)="userPutUnderReviewClicked($event)"
      (userRemoveFromReviewClicked)="userRemoveFromReviewClicked($event)"
      (userSilentHideClicked)="userSilentHideClicked($event)"
      (userSilentUnhideClicked)="userSilentUnhideClicked($event)"
      (userDeleteClicked)="userDeleteClicked($event)"
      (userBoostClicked)="userBoostClicked($event)"
      (userDeboostClicked)="userDeboostClicked($event)"
      (flagDetailsClicked)="flagDetailsClicked($event)"
      (sortChange)="sortChanged($event)"
    >
    </sa-users-table>

    <div class="empty-state" *ngIf="!isLoading && !hasError && data.length === 0">
      No flagged senders match these filters.
    </div>
  </div>

  <div class="container-fluid d-flex">
    <mat-paginator class="d-inline-block" [length]="resultsLength" [pageSize]="limit"
                   [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"></mat-paginator>
    <div class="d-flex flex-wrap align-content-center">
      <div class="pe-2">Go to </div>
      <input class="w-auto" matInput placeholder="page" (change)="pageChanged($event)">
    </div>
  </div>
</div>
